import React from "react";
import EachProject from "./EachProject";
import projects from "../file/projects.json";

function Projects() {
  const featured = [projects[0], projects[1], projects[3], projects[4]];

  return (
    <div className="projects-section">
      <div className="projects-inner">
        <div className="section-header">
          <div className="section-label">What I've built</div>
          <h2 className="section-title">Projects</h2>
        </div>

        <div className="projects-grid">
          {featured.map((project) => (
            <EachProject key={project.projectTitle} project={project} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;
